import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {EaColumnService} from "../../../service/api/ea-column.service";

@Component({
    selector: 'ea-column-detail-widget',
    templateUrl: './ea-column-detail-widget.component.html',
    standalone: false
})
export class EaColumnDetailWidgetComponent implements OnInit, OnChanges, OnDestroy {

    @Input() columnId: number;

    busy: boolean;
    initialized: boolean;
    columnData: any;

    constructor(
        protected columnService: EaColumnService
    ) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        if (this.columnId) {
            this.loadColumnData();
        }
        this.initialized = true;
    }

    loadColumnData() {
        this.busy = true;
        this.columnService.get(this.columnId).subscribe({
            next: (data) => {
                this.columnData = data;
                this.busy = false;
            },
            error: () => {
                this.busy = false;
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes["columnId"]) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
